import Amplify, { I18n, Hub } from "aws-amplify";
import { Auth } from "@aws-amplify/auth";
import * as Sentry from "@sentry/react";
import awsconfig from "../aws-exports";
import { dict } from "../vocabularies/disct";

Amplify.configure(awsconfig);
Auth.configure(awsconfig);
I18n.setLanguage("pt_BR");
I18n.putVocabularies(dict);

const listener = ({ payload }) => {
  if (payload.event.includes("failure")) {
    const sentryError = new Error(payload.data.message);
    Sentry.captureException(sentryError, (scope) => {
      scope.setTransactionName(`AWS Cognito Listener: ${payload.data.code}`);
      scope.setTag("AWS Cognito", payload.event);
      scope.setExtra("data", payload);
    });
  }
};

Hub.listen("auth", listener);
